import { Step as StepRoot } from './step';
import { StepHeader } from './step-header';
import { StepContent } from './step-content';
import { StepFooter } from './step-footer';

export const Step = {
  Root: StepRoot,
  Header: StepHeader,
  Content: StepContent,
  Footer: StepFooter,
};

export type { StepProps } from './types';
